// extracted by mini-css-extract-plugin
export var main = "layout-module--main--e5529";
export var pageWrapper = "layout-module--pageWrapper--18c19";